import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

// Actions
import * as TaskDataActions from './taskData.actions';

// Models
import { Task } from "src/app/shared/model/task";
import { TaskCategory } from "src/app/shared/model/taskCategory";
import { DataWithName } from "src/app/modules/shared/model/dataWithName";

// Services
import { CasesService } from 'src/app/cases/cases.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { LeadService } from 'src/app/leads/leadService';
import { OpportunityService } from 'src/app/opportunities/opportunity.service';
import { TypeService } from '../../api/type.service';
import { AccountService } from 'src/app/accounts/accountService';
import { TaskCategoryService } from 'src/app/shared/api/taskCategory.service';

@Injectable()
export class TaskDataEffects {
    constructor(
        private action$: Actions,
        private accountService: AccountService,
        private caseService: CasesService,
        private configService: ConfigurationService,
        private leadService: LeadService,
        private opportunityService: OpportunityService,
        private taskCategoryService: TaskCategoryService,
        private typeService: TypeService) {
    }

    getUserId(): number {
        const userData = JSON.parse(localStorage.getItem('user'));
        return userData?.userId;
    }

    getOrganizationId(): number {
        const userData = JSON.parse(localStorage.getItem('user'));
        return userData?.organizationId;
    }

    // GetTaskCategories$: Observable<Action> = createEffect(() =>
    //     this.action$.pipe(
    //         ofType(TaskDataActions.beginGetTaskCategories),
    //         mergeMap(() =>
    //             this.taskCategoryService.lionO36020APITaskCategoryGet(this.organizationId).pipe(
    //                 map((taskCategories: TaskCategory[]) => {
    //                     return TaskDataActions.successGetTaskCategories({ payload: taskCategories });
    //                 }),
    //                 catchError((error: Error) => {
    //                     return of(TaskDataActions.errorTaskCategories(error));
    //                 })
    //             )
    //         )
    //     )
    // );

    GetTaskCategories$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetTaskCategories),
            mergeMap(() =>
                this.taskCategoryService.lionO36020APITaskCategoryGet(this.getOrganizationId()).pipe(
                    map((taskCategories: TaskCategory[]) => {
                        return TaskDataActions.successGetTaskCategories({ payload: taskCategories });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetTaskModules$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetTaskModules),
            mergeMap(() =>
                this.configService.getModulesForQuestionnaire().pipe(
                    map((taskModules: any[]) => {
                        return TaskDataActions.successGetTaskModules({ payload: taskModules });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetAccountNames$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetAccountNames),
            mergeMap(() =>
                this.accountService.getAccountList(this.getOrganizationId(), this.getUserId()).pipe(
                    map((accountNames: DataWithName[]) => {
                        return TaskDataActions.successGetAccountNames({ payload: accountNames });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetLeadNames$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetLeadNames),
            mergeMap(() =>
                this.leadService.getAllLeadsNameList(this.getOrganizationId(), this.getUserId()).pipe(
                    map((leadNames: DataWithName[]) => {
                        return leadNames.length ? 
                        TaskDataActions.successGetLeadNames({ payload: leadNames }) : 
                        TaskDataActions.errorLeadNames({  
                            name: 'Error',
                            message: 'Lead Names not loaded...'
                        });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetOpportunityNames$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetOpportunityNames),
            mergeMap(() =>
                this.opportunityService.getAllOpportunitiesNameList(this.getOrganizationId(), this.getUserId()).pipe(
                    map((opportunityNames: DataWithName[]) => {
                        return TaskDataActions.successGetOpportunityNames({ payload: opportunityNames });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetCaseNames$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetCaseNames),
            mergeMap(() =>
                this.caseService.getAllTickets(0, 0, 0, 0, 0).pipe(
                    map((caseNames: DataWithName[]) => {
                        return TaskDataActions.successGetCaseNames({ payload: caseNames });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetReminderTypes$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(TaskDataActions.beginGetReminderTypes),
            mergeMap(() =>
                this.typeService.getReminderTypes().pipe(
                    map((remiderTypes: any[]) => {
                        return TaskDataActions.successGetReminderTypes({ payload: remiderTypes });
                    }),
                    catchError(() => [])
                )
            )
        )
    );
}